import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { FaUpload, FaFilePdf, FaTrash } from 'react-icons/fa';
import { colors } from '../../../../../assets/styles/GlobalStyles';
import { DocumentSection, DocumentList, FileInfo, RemoveButton } from './styles';

// Mesmo "Anexar mais documentos (opcional - apenas PDF)" do Protocolo Online
// (protocolo/components/DocumentUpload.js), pros pedidos com
// documentConfig.documentosAdicionais — os arquivos vão como 281 - Documentos Diversos.

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 8px;

  input {
    width: 18px;
    height: 18px;
    cursor: pointer;
    flex-shrink: 0;
  }

  span {
    color: ${colors.darkBlue};
    font-weight: 500;
  }
`;

const AreaUpload = styled.button`
  width: 100%;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
  font: inherit;
  color: inherit;

  &:hover:not(:disabled) {
    border-color: ${colors.lightBlue};
    background: #f1f5f9;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const ArquivoItem = styled(FileInfo)`
  max-width: none;
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
  }
`;

const Erro = styled.p`
  margin: 0.75rem 0 0;
  color: #dc2626;
  font-size: 0.8rem;
  white-space: pre-line;
  overflow-wrap: anywhere;
`;

const DocumentosAdicionais = ({ arquivos, erro, onAdicionar, onLimpar, onRemove, disabled }) => {
  const inputRef = useRef(null);
  const [marcado, setMarcado] = useState(false);

  const handleToggle = (event) => {
    setMarcado(event.target.checked);
    if (!event.target.checked) onLimpar();
  };

  const handleSelecionar = (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length > 0) onAdicionar(files);
    // Limpa o input pra permitir selecionar o mesmo arquivo de novo
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <DocumentSection>
      <CheckboxLabel>
        <input type="checkbox" checked={marcado} onChange={handleToggle} disabled={disabled} />
        <span>📎 Anexar mais documentos (opcional - apenas PDF)</span>
      </CheckboxLabel>

      {marcado && (
        <>
          <AreaUpload type="button" onClick={() => inputRef.current?.click()} disabled={disabled}>
            <FaUpload size={24} style={{ color: colors.lightBlue, marginBottom: '0.5rem' }} />
            <p style={{ margin: 0, fontWeight: 500 }}>Clique para adicionar mais arquivos PDF</p>
          </AreaUpload>
          <input
            ref={inputRef}
            type="file"
            multiple
            style={{ display: 'none' }}
            onChange={handleSelecionar}
            accept=".pdf,application/pdf"
          />

          {erro && <Erro role="alert">{erro}</Erro>}

          {arquivos.length > 0 && (
            <DocumentList style={{ marginTop: '1rem' }}>
              {arquivos.map(({ id, file }) => (
                <ArquivoItem key={id}>
                  <div>
                    <FaFilePdf color="#ef4444" />
                    <span title={file.name}>{file.name}</span>
                  </div>
                  <RemoveButton onClick={() => onRemove(id)} disabled={disabled} aria-label={`Remover ${file.name}`}>
                    <FaTrash size={12} />
                  </RemoveButton>
                </ArquivoItem>
              ))}
            </DocumentList>
          )}
        </>
      )}
    </DocumentSection>
  );
};

export default DocumentosAdicionais;
